module.exports = __webpack_public_path__ + "img/email-automation.b2441e80.png";